module.exports = __webpack_public_path__ + "img/c7-m.a8710867.jpg";